import { classes, stylesheet } from 'typestyle';

const css = stylesheet({
  dimmingWrapperRoot: {
    opacity: 1,
    transition: 'opacity 200ms',
  },
});

export const DimmingWrapper = ({
  children,
  dimActive,
  className,
}: {
  className?: string;
  children: React.ReactNode;
  dimActive: boolean;
}) => (
  <div
    aria-busy={dimActive}
    aria-live="polite"
    className={classes(css.dimmingWrapperRoot, className)}
    style={{
      opacity: dimActive ? 0.5 : 1,
    }}
  >
    {children}
  </div>
);
